/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_Insert_Segment_LabelInputs */



/**
* | output |
* | --- |
* | "Insert segment" |
*
* @param {Segment_Event_Group_Insert_Segment_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_insert_segment_label = /** @type {((inputs?: Segment_Event_Group_Insert_Segment_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_Insert_Segment_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inserer un segment")
	if (locale === "de") return /** @type {LocalizedString} */ ("Segment einfügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci segmento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить сегмент")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar segmento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插入段")
	if (locale === "ja") return /** @type {LocalizedString} */ ("セグメントを挿入")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खंड सम्मिलित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inserir segmento")
	return /** @type {LocalizedString} */ ("Insert segment")
});